
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductPendrivesDialog extends Serenity.EntityDialog<ProductPendrivesRow, any> {
        protected getFormKey() { return ProductPendrivesForm.formKey; }
        protected getIdProperty() { return ProductPendrivesRow.idProperty; }
        protected getLocalTextPrefix() { return ProductPendrivesRow.localTextPrefix; }
        protected getService() { return ProductPendrivesService.baseUrl; }
        protected getDeletePermission() { return ProductPendrivesRow.deletePermission; }
        protected getInsertPermission() { return ProductPendrivesRow.insertPermission; }
        protected getUpdatePermission() { return ProductPendrivesRow.updatePermission; }

        protected form = new ProductPendrivesForm(this.idPrefix);

    }
}